import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

/**
 * Generic side drawer used for the mobile/tablet project menu and other
 * full-height side overlays. Slides in from the left by default.
 */
export default function Drawer({ open, onClose, title, children, side = "left", width = 300 }) {
  const isLeft = side === "left";
  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            key="drw-bg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.18 }}
            className="fixed inset-0 bg-black/55 backdrop-blur-[2px]"
            style={{ zIndex: 70 }}
            onClick={onClose}
          />
          <motion.aside
            key="drw-fg"
            initial={{ x: isLeft ? -width : width }}
            animate={{ x: 0 }}
            exit={{ x: isLeft ? -width : width }}
            transition={{ duration: 0.22, ease: "easeOut" }}
            className={
              "fixed top-0 bottom-0 bg-ide-panel border-ide-border shadow-soft flex flex-col " +
              (isLeft ? "left-0 border-r" : "right-0 border-l")
            }
            style={{
              width,
              zIndex: 80,
              paddingTop: "max(0px, env(safe-area-inset-top, 0px))",
              paddingBottom: "max(0px, env(safe-area-inset-bottom, 0px))",
            }}
          >
            <div className="flex items-center px-3 py-2 border-b border-ide-border">
              <span className="text-sm font-medium text-ide-text">{title}</span>
              <button
                className="ml-auto text-ide-mute hover:text-ide-text rounded p-1 hover:bg-ide-surface"
                onClick={onClose}
                aria-label="Close drawer"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="flex-1 min-h-0 overflow-auto">{children}</div>
          </motion.aside>
        </>
      )}
    </AnimatePresence>
  );
}
